// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  b2cClientId:
    '2cdab02a-c38d-41d7-97b5-d7b291ed8d90',
  b2cScopeUrl:
    'https://adbihlerb2c.onmicrosoft.com/digitalbackenddev/access',
  b2cSigninOnly:
    'B2C_1A_HRD_SIGNIN_ONLY_DEV',
  b2cPasswordReset:
    'B2C_1A_PasswordReset_dev',
  b2cEditProfile:
    'B2C_1A_ProfileEdit_dev',
  publicBackendUrl:
    'https://fa-bihler-digital-public-backend-dev.azurewebsites.net/api',
  backendUrl:
    'https://fa-bihler-digital-backend-dev.azurewebsites.net/api'
};

export enum eRole {
  bihlerAdmin = 'bd-dev-bihlerDigital-bihler_admin',
  customerAdmin = 'bd-dev-digitalApp-customer_admin',
  user = 'bd-dev-digitalApp-customer_user'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
